require('./bootstrap');

import StarRating from 'vue-star-rating';
import ReadMore from 'vue-read-more';
import VModal from 'vue-js-modal';

const eventHub = new Vue();

Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        };
    }
});

Vue.use(VModal);

Vue.prototype.$http = axios;

/* Folosesti in vue v-click-outside="functie"
 pentru a executa o functie cand se face click in afara unui element
 */
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {

            if (!(el == event.target || el.contains(event.target))) {

                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

Vue.component('paginator', require('../components/Paginator.vue'));

Vue.component('star-rating', StarRating);

Vue.component('search-terms', require('../components/SearchTerms.vue'));

Vue.component('search-amenities', require('../components/RestaurantSearchAmenities.vue'));

Vue.component('home-search', require('../components/HomeSearch.vue'));

Vue.component('restaurant-search', require('../components/RestaurantSearch.vue'));

Vue.component('restaurant-questions', require('../components/RestaurantQuestions.vue'));

Vue.component('dishes-search', require('../components/DishesSearch.vue'));

// Vue.component('dishes-search-filters', require('../components/DishesSearchFilters.vue'));

Vue.component('restaurant-list-dishes', require('../components/ListDishesOnRestaurant.vue'));

Vue.component('feedback', require('../components/Feedback.vue'));

Vue.component('feedback-v2', require('../components/FeedbackV2'));

// Vue.component('restaurant-categories', require('../components/RestaurantCategories.vue'));

Vue.component('contribution-fields', require('../components/ContributionFields.vue'));

Vue.component('user-avatar', require('../components/UserAvatar.vue'));

Vue.component('modal-trigger', require('../components/ModalTrigger.vue'));

Vue.component('flat-map', require('../components/FlatMap.vue'));

Vue.component('restaurant-map', require('../components/RestaurantMap.vue'));

Vue.component('dish-map', require('../components/DishesCompaniesMap.vue'));

Vue.component('vote', require('../components/Vote.vue'));

Vue.component('search-rating', require('../components/RestaurantSearchRating.vue'));

Vue.component('search-company', require('../components/SearchCompany.vue'));

Vue.component('here-address-lookup', require('../components/HereAddressLookup.vue'));

Vue.component('search-range', require('../components/RestaurantSearchRange.vue'));

Vue.component('get-video', require('../components/Video.vue'));

Vue.component('lazy-load', require('../components/LazyLoad.vue'));

Vue.component('load-more', require('../components/LoadMore.vue'));

Vue.component('claim-restaurant', require('../components/ClaimRestaurant.vue'));

// Vue.component('advanced-contact-form', require('../components/AdvancedContactForm.vue'));

Vue.use(ReadMore);

Vue.filter('str_limit', function (value, limit) {
    if (!value) {
        return '';
    }

    value = value.toString();

    if (value.length <= limit) {
        return value;
    }

    return value.substring(0, limit) + '...';
});

Vue.filter('strip_tags', function (value) {
    if (!value) {
        return '';
    }

    return value.replace(/(<([^>]+)>)/gi, '');
});

Vue.filter('keyword_search_url', function (value, keyword) {
    if (!value) {
        return '';
    }

    keyword = keyword.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');

    return value + keyword;
});

new Vue({
    el: '#vue_id'
});

$(document).ready(function () {
    // $('#adblock-detect').on('hidden.bs.modal', function () {
    //     localStorage.setItem('adblock_popup_detected_viewed', 'true');
    // });

    navbarOnMobile();

    $(window).resize(function () {
        navbarOnMobile();
    });
});

window.oldBtnContent = '';
window.spinner = '<div class="spinner"></div>';

window.enableSpinner = function enableSpinner(selector) {
    selector.attr('disabled', true);
    window.oldBtnContent = selector.html();
    selector.css('width', selector.outerWidth());
    selector.html(window.spinner);
};

window.disabledSpinner = function disabledSpinner(selector) {
    selector.attr('disabled', false);
    selector.html(window.oldBtnContent);
    window.oldBtnContent = '';
};

window.readMore = function readMore(el, button, height = null) {
    if (el.height() > height) {
        el.css({
            'position': 'relative',
            'overflow': 'hidden',
            'height': height + 'px'
        });

        let readMoreContainer = '<div class="read-more-container"></div>';

        el.append($(readMoreContainer).html(button));
    }
};

window.scrollOnTabsToMainContent = function scrollOnTabsToMainContent(duration = 2000, offset = 140) {
    let withTimeout = true;

    if (screen.width >= 768) {
        offset = 0;
        withTimeout = false;
    }

    let url = window.location.href, idx = url.indexOf("#");
    let hash = idx != -1 ? url.substring(idx + 1) : "";

    let scrollTo;

    if (hash !== "") {
        scrollTo = '#' + hash;
        withTimeout = false;
    } else {
        if (screen.width >= 768) {
            return;
        }

        scrollTo = '#main-headline';
    }

    if (!$(scrollTo).length) {
        return;
    }

    if (withTimeout) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(scrollTo).offset().top - offset
            }, duration, 'swing');
        }, 1);
    } else {
        $('html, body').animate({
            scrollTop: $(scrollTo).offset().top - offset
        }, duration, 'swing');
    }
}

document.addEventListener('adblock-detected', function () {
    $('meta[name=_ewoiplnx]').prop('content', 'yes');

    if (
        localStorage.getItem('adblock_popup_detected_viewed') === null ||
        localStorage.getItem('adblock_popup_detected_viewed') === 'false'
    ) {
        $('#adblock-detect').modal('show');
    }
}, false);

document.addEventListener('adblock-undetected', function () {
    $('meta[name=_ewoiplnx]').prop('content', 'no');
}, false);

window.addEventListener('DOMContentLoaded', function () {
    (function ($) {
        $('.smooth-scroll').on('click', function (e) {
            e.preventDefault();

            let destination = $(this.hash);

            if (!destination.length) {
                return;
            }

            let offset = 0;

            if (screen.width < 768) {
                offset = 140;
            }

            if (e.target.dataset.offset) {
                offset = e.target.dataset.offset;
            }

            let animationDuration = 2000;

            if (e.target.dataset.duration) {
                animationDuration = parseInt(e.target.dataset.duration);
            }

            let scrollPosition = destination.offset().top - offset;

            $('html, body').animate({
                scrollTop: scrollPosition
            }, animationDuration);
        });
    })(jQuery);
});

function navbarOnMobile() {
    if (screen.width > 767) {
        return;
    }

    $('.navbar-collapse li.has-submenu > a').click(function () {
        $('.navbar-collapse li.has-submenu').each(function (index, el) {
            $(el).find('ul').addClass('sub-menu-hidden');
        });

        $(this).closest('.has-submenu').find('ul').removeClass('sub-menu-hidden');
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/app.js